import { HTTPResponse, IAbortableRequest, IPaginationResponse, ISignalable } from './http.types'

const generateEmptyPaginationResponse = (): HTTPResponse<IPaginationResponse> => {
  return {
    status: 'success',
    body: {
      totalCount: 0,
      nextPage: null,
      prevPage: null,
      items: [],
    },
  }
}

const createAbortableRequest = <T extends ISignalable>(request: T): IAbortableRequest<T> => {
  let abortCtrl = new AbortController()

  const abortableRequest = (...params) => {
    abortCtrl = new AbortController()

    return request(abortCtrl.signal, ...params)
  }

  const abort = () => abortCtrl.abort()

  abortableRequest.abort = abort

  return abortableRequest
}

const httpUtils = { generateEmptyPaginationResponse, createAbortableRequest }
export default httpUtils
